import Api from "..";
import {
  TransmedProofInput,
  TransmedProofValidationInput,
} from "../../dtos/transmed/process/proof";

export default class TransmedParticipationApi extends Api {
  constructor() {
    super("transmed/registration/participation");
  }

  public async post(data: TransmedProofInput): Promise<void> {
    return await super.post(data);
  }

  public async put(
    id: string,
    data: TransmedProofValidationInput
  ): Promise<void> {
    return await super.put(id, data);
  }
}
